import { connect } from 'react-redux';
import { fetchPosHoldsOrders, fetchPosHoldsOrdersDetail, voidSelectedPosHoldsOrder } from '../../actions/pos_actions';
import { setConfirmPasscodeModalVisibility, setPasscodeVerificationStatus } from '../../actions/baseModal_actions';

import PosHolds from '../../components/Sales/posHolds';

function mapStateToProps(state) {
  return {
    posHolds: state.pos.posHolds,
    posHoldsOderDetail: state.pos.posHoldsOderDetail,
    confirmPasscodeVerified: state.baseModals.confirmPasscodeModal.verified,

    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, {
  fetchPosHoldsOrders,
  fetchPosHoldsOrdersDetail,
  voidSelectedPosHoldsOrder,
  setConfirmPasscodeModalVisibility,
  setPasscodeVerificationStatus,
})(PosHolds);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/posHolds.jsx